import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { SuppliersSchema } from 'Modules/Suppliers/Schemas/TherapySchema';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';

export const useTherapySuppliersForm = () => {
  const therapySuppliersForm = useForm<ITherapySuppliers>({
    mode: 'onBlur',
    resolver: yupResolver(SuppliersSchema),
    defaultValues: {},
  });

  return {
    therapySuppliersForm,
  };
};
